import { render, staticRenderFns } from "./SliderLazy.vue?vue&type=template&id=a115a368&"
import script from "./SliderLazy.vue?vue&type=script&lang=js&"
export * from "./SliderLazy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports